import Vue from 'vue';
import VueRouter from 'vue-router';
import Dzp from '@/pages/Dzp';
import Login from '@/pages/Login';
import Admin from '@/pages/Admin';
import AdminActive from '@/pages/Admin/Active';
import AdminPrize from '@/pages/Admin/Prize';
import AdminRecord from '@/pages/Admin/Record';
import AdminStaff from '@/pages/Admin/Staff';
import Sign from '@/pages/Sign';
Vue.use(VueRouter);
export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            name: '大转盘',
            path: '/dzp/:id',
            component: Dzp,
            meta: {
                metaInfo: {
                    title: '邦邦抽奖-大转盘抽奖',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: '后台登录',
            path: '/login',
            component: Login,
            meta: {
                metaInfo: {
                    title: '邦邦抽奖-后台登录',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: '奖品核销',
            path: '/sign/:id',
            component: Sign,
            meta: {
                metaInfo: {
                    title: '邦邦抽奖-奖品核销',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: '后台首页',
            path: '/admin',
            component: Admin,
            redirect: '/admin/home',
            meta: {
                metaInfo: {
                    title: '邦邦抽奖-后台首页',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            },
            children: [
                {
                    name: '后台首页',
                    path: 'home',
                    component: AdminActive,
                    meta: {
                        metaInfo: {
                            title: '邦邦抽奖-后台主页',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '员工管理',
                    path: 'home',
                    component: AdminStaff,
                    meta: {
                        metaInfo: {
                            title: '邦邦抽奖-员工管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '奖品管理',
                    path: 'prize',
                    component: AdminPrize,
                    meta: {
                        metaInfo: {
                            title: '邦邦抽奖-奖品管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '抽奖记录',
                    path: 'record',
                    component: AdminRecord,
                    meta: {
                        metaInfo: {
                            title: '邦邦抽奖-抽奖记录',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                }
            ]
        },
        {
            path: '*',
            redirect: '/login'
        },
    ],
});